import { isValidElement, type ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface PageHeaderProps {
  title: string;
  description?: string;
  /** Ikona — buď komponenta (Server, ScanText) nebo hotový ReactNode (<Server size={18} />) */
  icon?: React.ComponentType<{ className?: string; size?: number | string }> | ReactNode;
  /** Akce vpravo nahoře — tlačítka, selecty atd. */
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  description,
  icon,
  actions,
  children,
  className,
}: PageHeaderProps) {
  let IconEl: ReactNode = null;
  if (icon) {
    if (isValidElement(icon)) {
      IconEl = icon;
    } else {
      const I = icon as React.ComponentType<{ className?: string; size?: number | string }>;
      IconEl = <I size={18} className='text-plex' />;
    }
  }

  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      <div>
        <div className='flex items-center gap-3'>
          {IconEl && (
            <span className='flex h-10 w-10 items-center justify-center rounded-xl acm-glass acm-glass-edge text-plex shrink-0'>
              {IconEl}
            </span>
          )}
          <h1 className='text-2xl font-extrabold text-gray-100 tracking-tight'>{title}</h1>
        </div>
        {description && <p className='text-sm text-gray-500 mt-1.5 max-w-2xl'>{description}</p>}
      </div>
      {(actions || children) && (
        <div className='flex items-center gap-2 shrink-0'>
          {actions}
          {children}
        </div>
      )}
    </div>
  );
}
